import { isAuthenticated } from '../utils/authHelper';
import React, { Fragment } from 'react'
import Paper from '@material-ui/core/Paper'
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Snackbar from '@material-ui/core/Snackbar';
import Header from './Header'
import Button from '@material-ui/core/Button'
import DialogActions from '@material-ui/core/DialogActions';
import { viewBlobFile, viewFile } from './viewFileUtilFunction';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import RaisedButton from 'material-ui/RaisedButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Grid from '@material-ui/core/Grid';
import { browserHistory } from 'react-router'
import moment from 'moment';
import {
  vendorOnboardRequest, updateVendorRequest,
  updateApprovedRequest, updateRejectedRequest,
  validateGSTN,
  validatePancard
} from '../utils/VendorApiUtils'
var BrowserHistory = require('react-router/lib/browserHistory');

class VendorPreview extends React.Component {
  constructor(props) {
    super(props)
    if (!isAuthenticated()) {
      browserHistory.push('/')
    }
    this.state = {
      data: {
        name: '',
        contact_person_name: '',
        address: '',
        city_name: '',
        state_name: '',
        contact_number: '',
        alternate_contact_number: '',
        email_id: '',
        payment_mode: '',
        beneficiary_name: '',
        bank_acc_number: '',
        ifsc_code: '',
        bank_name: '',
        cancel_cheque_upload_file: null,
        cancel_cheque_upload_file_name: '',
        msme_vendor: '',
        msme_certificate_file: null,
        msme_certificate_file_name: '',
        vendor_agreement: '',
        vendor_agreement_file: null,
        vendor_agreement_file_name: '',
        agreement_expiry_date: '',
        defaultor_amount: 0,
        vendor_ldc_agreement: '',
        vendor_ldc_agreement_file: null,
        vendor_ldc_agreement_file_name: '',
        ldc_agreement_start_date: '',
        ldc_agreement_end_date: '',
        msme_certificate: '',
        gstn: '',
        gstn_verified: '',
        gstn_verification_remarks: '',
        gstn_status: '',
        tds_liability: '',
        tds_liability_remarks: '',
        tds_slab: '',
        it_section_applicable: '',
        pancard_number: '',
        pancard_file: undefined,
        pancard_file_name: '',
        aadhar_number: '',
        aadhar_file: undefined,
        aadhar_file_name: '',
        company_category: '',
        contractual_terms: '',
        city_finance_remarks: '',
        central_finance_remarks: '',
        legal_name: '',
        entity_type: '',
        registration_type: '',
        department_code: '',
        nature_of_business: '',
        registration_date: '',
        state: '',
        vendor_approver_l2_remarks: '',
      },
      dialogBox: false,
      status: '',
      dialogBoxText: '',
      inRequest: false,
      snackText: '',
      snackOpen: false,
    }
  }
  componentDidMount(props) {
    if (this.props.location && this.props.location.state !== undefined) {
      this.setState({ 
        data: { 
          ...this.props.location.state,
          agreement_expiry_date: this.props.location.state.agreement_expiry_date ? new Date(this.props.location.state.agreement_expiry_date) : null,
          ldc_agreement_start_date: this.props.location.state.ldc_agreement_start_date ? new Date(this.props.location.state.ldc_agreement_start_date) : null,
          ldc_agreement_end_date: this.props.location.state.ldc_agreement_end_date ? new Date(this.props.location.state.ldc_agreement_end_date) : null,
        } 
      })
    }
    else if (this.props.data) {
      this.setState({ 
        data: { 
          ...this.props.data,
          agreement_expiry_date: this.props.data.agreement_expiry_date ? new Date(this.props.data.agreement_expiry_date) : null, 
          ldc_agreement_start_date: this.props.data.ldc_agreement_start_date ? new Date(this.props.data.ldc_agreement_start_date) : null,
          ldc_agreement_end_date: this.props.data.ldc_agreement_end_date ? new Date(this.props.data.ldc_agreement_end_date) : null
        } 
      })
    }
    else {
      browserHistory.push('/')
    }
  }
  async sendToAprroval() {
    /*disabling the submit button*/
    console.log("idharrrr");
    this.setState({ inRequest: true });
    let response
    if (this.state.data.state !== 'edit')
    {
      response = await validateGSTN(this.state.data.gstn)
      if (response) {
        if (response.status !== 'success') {
          this.setState({ snackText: response.message, snackOpen: true })
          return false
        }
      }
      const pancardValidationResponse = await validatePancard(this.state.data.pancard_number);
      if (pancardValidationResponse) {
        if (pancardValidationResponse.status === 'duplicate') {
          this.setState({ snackText: pancardValidationResponse.message, snackOpen: true })
          return false;
        }
      }
    }
    let formData = new FormData()
    Object.keys(this.state.data).map(data => {
      if(data == 'ldc_tds_rate_data'){
        formData.append(data, JSON.stringify(this.state.data[data]))
      } else {
        formData.append(data, this.state.data[data])
      }
    })
    if (this.state.data.state === 'onboard') {
      response = await vendorOnboardRequest(formData)
    }
    else if (this.state.data.state === 'edit' && (this.state.data.status === 'pending' || this.state.data.status === 'approved_by_central_finance')) {
      response = await updateVendorRequest(formData)
    }
    else if (this.state.data.state === 'edit' && this.state.data.status === 'rejected') {
      // if the vendor was rejected due to BUF failure, we need to update it
      if(this.state.data.transaction_type === 'rejected_by_bank'){
        response = await updateApprovedRequest(formData)
      }
      else
        response = await updateRejectedRequest(formData)
    }
    else if (this.state.data.state === 'edit' && this.state.data.status === 'approved') {
      response = await updateApprovedRequest(formData)
    }
    if (response) {
      if (response.status === 'success') {
        this.setState({ dialogBox: true, dialogBoxText: 'Vendor request has been sent for approval' })
      }
      else if (response.status === 'failure') {
        this.setState({ dialogBox: true, dialogBoxText: response.message })
      }
    }
  }
  handleCloseSnack() {
    this.setState({ snackOpen: false })
  }
  handleClose() {
    if (typeof this.state.data.status !== 'undefined')
    {
      switch (this.state.data.status)
      {
        case 'onboard':
        case 'pending':
        case 'approval':
        case 'approved':
          browserHistory.push(`/vendor/${this.state.data.status}`);
          break;
        default:
          window.location.reload();
          break;
      }
    }
    else
      window.location.reload();
  }

  handleBack() {
    BrowserHistory.goBack()
  }
  getContent() {
    return (<div>
      <Grid item xs={12} md={4}>
        <List >
          <ListItem >

            <ListItemText style={{ minWidth: '240px' }} primary=" Vendor name" />
            <ListItemText style={{ minWidth: '10px' }} primary=":" />
            <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.name} />
          </ListItem>
          <ListItem>

            <ListItemText style={{ minWidth: '240px' }} primary=" Contact Person Name" />
            <ListItemText style={{ minWidth: '10px' }} primary=":" />
            <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.contact_person_name}
            />
          </ListItem>
          <ListItem>

            <ListItemText style={{ minWidth: '240px' }} primary="Vendor Address " />
            <ListItemText style={{ minWidth: '10px' }} primary=":" />
            <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.address}
            />
          </ListItem>
          <ListItem>

            <ListItemText style={{ minWidth: '240px' }} primary=" Vendor City" />
            <ListItemText style={{ minWidth: '10px' }} primary=":" />
            <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.city_name}
            />
          </ListItem>
          <ListItem>

            <ListItemText style={{ minWidth: '240px' }} primary=" Vendor State" />
            <ListItemText style={{ minWidth: '10px' }} primary=":" />
            <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.state_name}
            />
          </ListItem>
          <ListItem>

            <ListItemText style={{ minWidth: '240px' }} primary=" National Vendor" />
            <ListItemText style={{ minWidth: '10px' }} primary=":" />
            <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.national?'Yes':'No'}
            />
          </ListItem>
          <ListItem>
            <ListItemText style={{ minWidth: '240px' }} primary=" Contact Number" />
            <ListItemText style={{ minWidth: '10px' }} primary=":" />
            <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.contact_number}
            />
          </ListItem>
          {this.state.data.alternate_contact_number && <ListItem>

            <ListItemText style={{ minWidth: '240px' }} primary="Alternate Contact Number" />
            <ListItemText style={{ minWidth: '10px' }} primary=":" />
            <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.alternate_contact_number}
            />
          </ListItem>}
          <ListItem>

            <ListItemText style={{ minWidth: '240px' }} primary="Email Id" />
            <ListItemText style={{ minWidth: '10px' }} primary=":" />
            <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.email_id} />
          </ListItem>
          <ListItem>
            <ListItemText style={{ minWidth: '240px' }} primary="GST Number" />
            <ListItemText style={{ minWidth: '10px' }} primary=":" />
            <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.gstn}
            />
          </ListItem>
          <ListItem>
            <ListItemText style={{ minWidth: '240px' }} primary="GST Verified" />
            <ListItemText style={{ minWidth: '10px' }} primary=":" />
            <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.gstn_verified}
            />
          </ListItem>
          <ListItem>
            <ListItemText style={{ minWidth: '240px' }} primary="GST Status" />
            <ListItemText style={{ minWidth: '10px' }} primary=":" />
            <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.gstn_status}
            />
          </ListItem>
          {this.state.data.gstn_verified !== 'yes' ? <ListItem>
            <ListItemText style={{ minWidth: '240px' }} primary="GST Verification Remarks" />
            <ListItemText style={{ minWidth: '10px' }} primary=":" />
            <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.gstn_verification_remarks}
            />
          </ListItem> : <div> <ListItem>
            <ListItemText style={{ minWidth: '240px' }} primary="Legal Name" />
            <ListItemText style={{ minWidth: '10px' }} primary=":" />
            <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.legal_name}
            />
          </ListItem> <ListItem>
                <ListItemText style={{ minWidth: '240px' }} primary="Entity Type" />
                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.entity_type}
                />
              </ListItem> <ListItem>
                <ListItemText style={{ minWidth: '240px' }} primary="Registration Type" />
                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.registration_type}
                />
              </ListItem> <ListItem>
                <ListItemText style={{ minWidth: '240px' }} primary="Department Code" />
                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.department_code}
                />
              </ListItem> <ListItem>
                <ListItemText style={{ minWidth: '240px' }} primary="Nature Of Business" />
                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.nature_of_business}
                />
              </ListItem> <ListItem>
                <ListItemText style={{ minWidth: '240px' }} primary="Registration Date" />
                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={ this.state.data.registration_date ? moment(this.state.data.registration_date).format('YYYY-MM-DD') : 'Not Specified'}
                />
              </ListItem></div>}
          <ListItem>
            <ListItemText style={{ minWidth: '240px' }} primary="Payment Mode" />
            <ListItemText style={{ minWidth: '10px' }} primary=":" />
            <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.payment_mode}
            />
          </ListItem>
          {this.state.data.payment_mode === 'online payment' && <div>
            <ListItem>
              <ListItemText style={{ minWidth: '240px' }} primary="Trade licence file" />
              <ListItemText style={{ minWidth: '10px' }} primary=":" />
              {
                ((this.state.data.trade_licence_file !== null && this.state.data.trade_licence_file !== "") || this.state.data.trade_licence_file_name !== "") ?
                (typeof(this.state.data.trade_licence_file) !== 'string') ?
                <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={<Button style={{'backgroundColor':'rgb(0,188,212)','width':'50px','height':'20px','color':'white'}} onClick={()=>viewBlobFile(this.state.data.trade_licence_file)}>View</Button>}/>:
                <ListItemText style={{ minWidth: '240px' }} primary={<Button style={{'backgroundColor':'rgb(0,188,212)','width':'50px','height':'20px','color':'white'}} onClick={()=>viewFile(this.state.data.trade_licence_file)}>View</Button>} />
                :
                <ListItemText style={{ minWidth: '240px' }} primary="N.A" />
              }
            </ListItem>
            <ListItem>
            <ListItemText style={{ minWidth: '240px' }} primary="Beneficiary Name" />
            <ListItemText style={{ minWidth: '10px' }} primary=":" />
            <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.beneficiary_name}
            />
          </ListItem>
            <ListItem>

              <ListItemText style={{ minWidth: '240px' }} primary="Bank Account Number" />
              <ListItemText style={{ minWidth: '10px' }} primary=":" />
              <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.bank_acc_number}
              />
            </ListItem>
            <ListItem>
              <ListItemText style={{ minWidth: '240px' }} primary="IFSC Code" />
              <ListItemText style={{ minWidth: '10px' }} primary=":" />
              <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.ifsc_code}
              />
            </ListItem>
            <ListItem>
              <ListItemText style={{ minWidth: '240px' }} primary="Bank Name" />
              <ListItemText style={{ minWidth: '10px' }} primary=":" />
              <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.bank_name}
              />
            </ListItem>
            {this.state.data.cancel_cheque_upload_file !== '' && this.state.data.cancel_cheque_upload_file &&
              <ListItem>
                <ListItemText style={{ minWidth: '240px' }} primary="Cancel Cheque Copy" />
                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                {
                  (typeof(this.state.data.cancel_cheque_upload_file) === 'string')?
                  <ListItemText style={{ minWidth: '240px' }} primary={<Button style={{'backgroundColor':'rgb(0,188,212)','width':'50px','height':'20px','color':'white'}} onClick={()=>viewFile(this.state.data.cancel_cheque_upload_file)}>View</Button>} />:
                  <ListItemText style={{ minWidth: '240px' }} primary={<Button style={{'backgroundColor':'rgb(0,188,212)','width':'50px','height':'20px','color':'white'}} onClick={()=>viewBlobFile(this.state.data.cancel_cheque_upload_file)}>View</Button>} />
                }
              </ListItem>}</div>}
          {this.state.data.tds_liability !== '' && this.state.data.tds_liability && <ListItem>
            <ListItemText style={{ minWidth: '240px' }} primary="TDS Liability" />
            <ListItemText style={{ minWidth: '10px' }} primary=":" />
            <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.tds_liability}
            />
          </ListItem>}
          {this.state.data.tds_liability_remarks !== '' && this.state.data.tds_liability_remarks
            && <ListItem>
              <ListItemText style={{ minWidth: '240px' }} primary="TDS Liablity Remarks" />
              <ListItemText style={{ minWidth: '10px' }} primary=":" />
              <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.tds_liability_remarks}
              />
            </ListItem>}
          {this.state.data.tds_liability === 'yes' && this.state.data.pancard_number !== '' && this.state.data.pancard_number
            && <ListItem>
              <ListItemText style={{ minWidth: '240px' }} primary="Pan Number" />
              <ListItemText style={{ minWidth: '10px' }} primary=":" />
              <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.pancard_number}
              />
            </ListItem>}
          {this.state.data.tds_liability === 'yes' && ((this.state.data.pancard_scan_copy !== '' && this.state.data.pancard_scan_copy) || (this.state.data.pancard_file_name !== '' && this.state.data.pancard_file_name))
            && <ListItem>
              <ListItemText style={{ minWidth: '240px' }} primary="Pan Number File Name" />
              <ListItemText style={{ minWidth: '10px' }} primary=":" />
              {
                (this.state.data.pancard_file !== undefined)?
                <ListItemText style={{ minWidth: '240px' }} primary={<Button style={{'backgroundColor':'rgb(0,188,212)','width':'50px','height':'20px','color':'white'}} onClick={()=>viewBlobFile(this.state.data.pancard_file)}>View</Button>} />:
                null
              }
              { (this.state.data.pancard_file === undefined)?
                (this.state.data.pancard_file_name)?
                <ListItemText style={{ minWidth: '240px' }} primary={<Button style={{'backgroundColor':'rgb(0,188,212)','width':'50px','height':'20px','color':'white'}} onClick={()=>viewFile(this.state.data.pancard_file_name)}>View</Button>} />:null
                :null
              }
            </ListItem>}
            {this.state.data.tds_liability === 'yes'
            && <ListItem>
              <ListItemText style={{ minWidth: '240px' }} primary="Pan Status" />
              <ListItemText style={{ minWidth: '10px' }} primary=":" />
              <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.pancard_status == '0' ? 'Inoperative' : 'Operative'}
              />
            </ListItem>}
          {this.state.data.tds_liability === 'yes' && this.state.data.aadhar_number !== '' && this.state.data.aadhar_number
            && <ListItem>
              <ListItemText style={{ minWidth: '240px' }} primary="Aadhaar Number" />
              <ListItemText style={{ minWidth: '10px' }} primary=":" />
              <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.aadhar_number}
              />
            </ListItem>}
          {this.state.data.tds_liability === 'yes' && ((this.state.data.aadhar_scan_copy !== '' && this.state.data.aadhar_scan_copy) || (this.state.data.aadhar_file_name !== '' && this.state.data.aadhar_file_name))
            && <ListItem>
              <ListItemText style={{ minWidth: '240px' }} primary="Aadhaar Number File Name" />
              <ListItemText style={{ minWidth: '10px' }} primary=":" />
              {
                (this.state.data.aadhar_file !== undefined)?
                <ListItemText style={{ minWidth: '240px' }} primary={<Button style={{'backgroundColor':'rgb(0,188,212)','width':'50px','height':'20px','color':'white'}} onClick={()=>viewBlobFile(this.state.data.aadhar_file)}>View</Button>} />:
                null
              }
              { (this.state.data.aadhar_file === undefined)?
                (this.state.data.aadhar_file_name)?
                <ListItemText style={{ minWidth: '240px' }} primary={<Button style={{'backgroundColor':'rgb(0,188,212)','width':'50px','height':'20px','color':'white'}} onClick={()=>viewFile(this.state.data.aadhar_file_name)}>View</Button>} />:null
                :null
              }
            </ListItem>}
          <ListItem>
            <ListItemText style={{ minWidth: '240px' }} primary="Vendor Agreement" />
            <ListItemText style={{ minWidth: '10px' }} primary=":" />
            <ListItemText style={{ minWidth: '240px' }} primary={(this.state.data.vendor_agreement && this.state.data.vendor_agreement.toString() === '1')?'Yes':'No'} />
          </ListItem>
          {this.state.data.vendor_agreement && this.state.data.vendor_agreement.toString() === '1'
            ? (
              <Fragment>
                <ListItem>
                  <ListItemText style={{ minWidth: '240px' }} primary="Agreement Expiry Date" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.agreement_expiry_date && this.state.data.agreement_expiry_date.toDateString()} />
                </ListItem>
                <ListItem>
                  <ListItemText style={{ minWidth: '240px' }} primary="Vendor Agreement File" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  {
                    (this.state.data.vendor_agreement && this.state.data.vendor_agreement.toString() === '1') ?
                      (typeof(this.state.data.vendor_agreement_file) !== 'string' && this.state.data.vendor_agreement_file !== undefined && this.state.data.vendor_agreement_file !== null) ?
                        <ListItemText style={{ minWidth: '240px' }} primary={<Button style={{'backgroundColor':'rgb(0,188,212)','width':'50px','height':'20px','color':'white'}} onClick={()=>viewBlobFile(this.state.data.vendor_agreement_file)}>View</Button>}/>:
                        <ListItemText style={{ minWidth: '240px' }} primary={<Button style={{'backgroundColor':'rgb(0,188,212)','width':'50px','height':'20px','color':'white'}} onClick={()=>viewFile(this.state.data.vendor_agreement_file_name)}>View</Button>} />
                      :
                      <ListItemText style={{ minWidth: '240px' }} primary="N.A" />
                  }
                </ListItem>
              </Fragment>
            ) : null}
          <ListItem>
            <ListItemText style={{ minWidth: '240px' }} primary="MSME Vendor" />
            <ListItemText style={{ minWidth: '10px' }} primary=":" />
            <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={(this.state.data.msme_vendor !== null && this.state.data.msme_vendor.toString() === '1')?'Yes':'No'} />
          </ListItem>
          {this.state.data.msme_vendor !== null && this.state.data.msme_vendor.toString() === '1'
           && <ListItem>
            <ListItemText style={{ minWidth: '240px' }} primary="MSME Certificate File Name" />
            <ListItemText style={{ minWidth: '10px' }} primary=":" />
            {
              (this.state.data.msme_vendor.toString() === '1') ?
                (typeof(this.state.data.msme_certificate_file) !== 'string' && this.state.data.msme_certificate_file !== undefined && this.state.data.msme_certificate_file !== null) ?
                  <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={<Button style={{'backgroundColor':'rgb(0,188,212)','width':'50px','height':'20px','color':'white'}} onClick={()=>viewBlobFile(this.state.data.msme_certificate_file)}>View</Button>}/>:
                  <ListItemText style={{ minWidth: '240px' }} primary={<Button style={{'backgroundColor':'rgb(0,188,212)','width':'50px','height':'20px','color':'white'}} onClick={()=>viewFile(this.state.data.msme_certificate)}>View</Button>} />
                :
                <ListItemText style={{ minWidth: '240px' }} primary="N.A" />
            }
          </ListItem>}
          {this.state.data.company_category && <ListItem>
            <ListItemText style={{ minWidth: '240px' }} primary="Company Category" />
            <ListItemText style={{ minWidth: '10px' }} primary=":" />
            <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.company_category}
            />
          </ListItem>}
          {this.state.data.contractual_terms && <ListItem>
            <ListItemText style={{ minWidth: '240px' }} primary="Contractual Terms" />
            <ListItemText style={{ minWidth: '10px' }} primary=":" />
            <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.contractual_terms}
            />
          </ListItem>}
          <ListItem>
            <ListItemText style={{ minWidth: '240px' }} primary="Vendor Defaulted Amount" />
            <ListItemText style={{ minWidth: '10px' }} primary=":" />
            <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.defaultor_amount}
            />
          </ListItem>
          <ListItem>
            <ListItemText style={{ minWidth: '240px' }} primary="Vendor LDC Agreement" />
            <ListItemText style={{ minWidth: '10px' }} primary=":" />
            <ListItemText style={{ minWidth: '240px' }} primary={(this.state.data.vendor_ldc_agreement && this.state.data.vendor_ldc_agreement.toString() === '1')?'Yes':'No'} />
          </ListItem>
          {this.state.data.vendor_ldc_agreement && this.state.data.vendor_ldc_agreement.toString() === '1'
            ? (
              <Fragment>
                <ListItem>
                  <ListItemText style={{ minWidth: '240px' }} primary="LDC Agreement Start Date" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.ldc_agreement_start_date && this.state.data.ldc_agreement_start_date.toDateString()} />
                </ListItem>
                <ListItem>
                  <ListItemText style={{ minWidth: '240px' }} primary="LDC Agreement End Date" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.ldc_agreement_end_date && this.state.data.ldc_agreement_end_date.toDateString()} />
                </ListItem>
                {this.state.data.ldc_tds_rate_data && this.state.data.ldc_tds_rate_data.map((data, index) => (
                  <ListItem key={index}>
                    <ListItemText style={{ minWidth: '240px' }} primary={data.tds_section_name || 'TDS Section'} />
                    <ListItemText style={{ minWidth: '10px' }} primary=":" />
                    <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={
                    <div>
                      <span>{`LDC Limit: \u20B9 ${data.ldc_amount_limit}`}</span><br/>
                      <span>LDC Rate: {data.ldc_rate}</span>
                    </div>} />
                  </ListItem>
                ))}
                <ListItem>
                  <ListItemText style={{ minWidth: '240px' }} primary="Vendor LDC Agreement File" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  {
                    (this.state.data.vendor_ldc_agreement && this.state.data.vendor_ldc_agreement.toString() === '1') ?
                      (typeof(this.state.data.vendor_ldc_agreement_file) !== 'string' && this.state.data.vendor_ldc_agreement_file !== undefined && this.state.data.vendor_ldc_agreement_file !== null) ?
                        <ListItemText style={{ minWidth: '240px' }} primary={<Button style={{'backgroundColor':'rgb(0,188,212)','width':'50px','height':'20px','color':'white'}} onClick={()=>viewBlobFile(this.state.data.vendor_ldc_agreement_file)}>View</Button>}/>:
                        <ListItemText style={{ minWidth: '240px' }} primary={<Button style={{'backgroundColor':'rgb(0,188,212)','width':'50px','height':'20px','color':'white'}} onClick={()=>viewFile(this.state.data.vendor_ldc_agreement_file_name)}>View</Button>} />
                      :
                      <ListItemText style={{ minWidth: '240px' }} primary="N.A" />
                  }
                </ListItem>
              </Fragment>
            ) : null}
          <ListItem>
            <ListItemText style={{ minWidth: '240px' }} primary="Vendor Approver L2 comment" />
            <ListItemText style={{ minWidth: '10px' }} primary=":" />
            <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.vendor_approver_l2_remarks}
            />
          </ListItem>
          <ListItem>
            <ListItemText style={{ minWidth: '240px' }} primary="Central finance comment" />
            <ListItemText style={{ minWidth: '10px' }} primary=":" />
            <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.central_finance_remarks}
            />
          </ListItem>
          <ListItem>
            <ListItemText style={{ minWidth: '240px' }} primary="City finance comment" />
            <ListItemText style={{ minWidth: '10px' }} primary=":" />
            <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.city_finance_remarks}
            />
          </ListItem>
        </List>
      </Grid>
      {(this.state.data.state === 'onboard' || this.state.data.state === 'edit') && <div style={{ display: 'flex', justifyContent: 'center' }}>
        <RaisedButton primary={true} label={`Back`} color="primary" style={{ marginTop: '30px', marginBottom: '30px' }} onClick={this.props.handleBack.bind(this, this.state.data)} />
        <RaisedButton label={this.state.data.state === 'edit' ? 'Send changes for approval' : 'Send for Approval'} labelColor={`white`} backgroundColor='rgb(121,183,79)' style={{ marginTop: '30px', marginBottom: '30px', marginLeft: '12px' }} onClick={this.sendToAprroval.bind(this)} disabled={this.state.inRequest} />


      </div>}
      {this.state.data.state === 'info' && <div style={{ display: 'flex', justifyContent: 'center' }}>
        <RaisedButton primary={true} label={`Go Back`} color="primary" style={{ marginTop: '30px', marginBottom: '30px' }} onClick={this.handleBack.bind(this)} />
      </div>}
    </div>
    )
  }
  render() {
    return (
      <MuiThemeProvider>
        {this.state.data.state === 'info' && <Header />}
        {this.state.data.state === 'info' && <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
          <Paper style={{ width: '700px', height: 'auto' }} elevation={1}>

            <div style={{ marginLeft: '68px' }}>{this.getContent()}</div>
          </Paper>
        </div>}
        {this.state.data.state !== 'info' && this.getContent()}
        <Dialog
          modal={false}
          open={this.state.dialogBox}
          onClose={this.handleClose.bind(this)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <h4 style={{ textAlign: 'center' }}>{this.state.dialogBoxText}</h4>
            </DialogContentText>
          </DialogContent>
          <RaisedButton primary={true} onClick={this.handleClose.bind(this)} label="OK" />
        </Dialog>
        <Snackbar
            open={this.state.snackOpen}
            autoHideDuration={1000}
            onClose={this.handleCloseSnack.bind(this)}
            message={this.state.snackText}
        />
      </MuiThemeProvider>
    )
  }
}
export default VendorPreview



// WEBPACK FOOTER //
// ./src/components/VendorPreview.js